import type { ReactNode } from "react";
import React from "react";
import { css } from "@emotion/css";

const mutedStyles = css({
  fontStyle: "italic",
  opacity: 0.6,
});

// De-emphasised placeholder for an empty value in a table cell or detail field,
// e.g. "—", "(no label)" or "None set".
export function MutedPlaceholder({ children }: { children: ReactNode }) {
  return <span className={mutedStyles}>{children}</span>;
}

// The house placeholder for a value the record simply doesn't carry. Prefer a phrase over the dash
// where the emptiness itself needs explaining, e.g. "(no label)".
export function EmptyValue() {
  return <MutedPlaceholder>—</MutedPlaceholder>;
}
